import * as actions from '../constants/actions';

interface IInitialState {
  validated: any;
  validatedDate: Date | undefined;
}

const initialState: IInitialState = {
  validated: undefined,
  validatedDate: undefined
};

function reducer(state = initialState, { type, payload }) {
  switch (type) {
    case actions.AGE_GATE_VALIDATED:
      return {
        ...state,
        validated: true,
        validatedDate: Date.now()
      };

    case actions.AGE_GATE_NOT_VALIDATED:
      return {
        ...state,
        validated: false,
        validatedDate: undefined
      };

    default:
      return state;
  }
}

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/ageGate.ts